import {
  GET_LEADS_ENVIADOS,
  GET_LEADS_SUCCESS,
  GET_LEADS_FAIL,
  CREATE_LEAD,
  UPDATE_LEAD,
  CREATE_LEAD_FAIL,
  CREATE_LEAD_SUCCESS,
  UPDATE_LEAD_SUCCESS,
  UPDATE_LEAD_FAIL,
  SEND_LEAD,
  SEND_LEAD_SUCCESS,
  SEND_LEAD_FAIL,
  CLEAR_SEND_LEAD_RESULT
} from "./actionTypes"

export const getLeadsEnviados = leads => ({
  type: GET_LEADS_ENVIADOS,
  payload: leads,
})

export const getLeadsSuccess = leads => ({
  type: GET_LEADS_SUCCESS,
  payload: leads,
})

export const getLeadsFail = error => ({
  type: GET_LEADS_FAIL,
  payload: error,
})


export const createLead = lead => ({
  type: CREATE_LEAD,
  payload: lead,
})

export const createLeadSuccess = lead => ({
  type: CREATE_LEAD_SUCCESS,
  payload: lead,
})

export const createLeadFail = error => ({
  type: CREATE_LEAD_FAIL,
  payload: error,
})

export const updateLead = lead => ({
  type: UPDATE_LEAD,
  payload: lead,
})

export const updateLeadSuccess = lead => ({
  type: UPDATE_LEAD_SUCCESS,
  payload: lead,
})

export const updateLeadFail = error => ({
  type: UPDATE_LEAD_FAIL,
  payload: error,
})

export const sendLead = lead => ({
  type: SEND_LEAD,
  payload: lead,
})

export const sendLeadSuccess = lead => ({
  type: SEND_LEAD_SUCCESS,
  payload: lead,
})

export const sendLeadFail = error => ({
  type: SEND_LEAD_FAIL,
  payload: error,
})

export const clearSendLeadResult = () => ({
  type: CLEAR_SEND_LEAD_RESULT,
})




